export const getBase64Image = img => {
  // Create an empty canvas element
  const canvas = document.createElement("canvas");
  const { imageRef } = img;
  canvas.width = imageRef.width;
  canvas.height = imageRef.height;

  // Copy the image contents to the canvas
  const ctx = canvas.getContext("2d");
  ctx.drawImage(imageRef, 0, 0);

  // Get the data-URL formatted image
  // Firefox supports PNG and JPEG. You could check img.src to
  // guess the original format, but be aware the using "image/jpg"
  // will re-encode the image.
  const dataURL = canvas.toDataURL("image/png");

  return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
};

// This is how `react-image-crop` computes the pixelCrop values
export const getPixelCrop = (image, crop) => {
  return {
    x: Math.round(image.width * (crop.x / 100)),
    y: Math.round(image.height * (crop.y / 100)),
    width: Math.round(image.width * (crop.width / 100)),
    height: Math.round(image.height * (crop.height / 100)),
  };
};



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/utils.js